import { render } from "./editAcupoint.vue?vue&type=template&id=6490bfd0&scoped=true"
import script from "./editAcupoint.vue?vue&type=script&lang=js"
export * from "./editAcupoint.vue?vue&type=script&lang=js"

import "./editAcupoint.vue?vue&type=style&index=0&id=6490bfd0&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6490bfd0"]])

export default __exports__